if (!customElements.get('section-video')) {
  class SectionVideo extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        template: this.querySelector('#video-template'),
        container: this.querySelector('#video-container'),
        playButton: this.querySelector('.video-play'),
        previewImage: this.querySelector('.preview-image'),
        stopButton: this.querySelector('.video-stop')
      };

      this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
        rootMargin: '200px', // preload a bit earlier
        threshold: 0
      });

      if (this.selectors.container) {
        this.observer.observe(this.selectors.container);
      }
    }

    onIntersection(entries) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        this.observer.disconnect();
        this.initVideo(); // Load video only when in view
      }
    }

    initVideo() {
      const videoClone = this.selectors.template.content.cloneNode(true);
      this.selectors.container.appendChild(videoClone);

      const videoElement = this.selectors.container.querySelector('video');
      if (videoElement) {
        videoElement.removeAttribute('autoplay');
        videoElement.removeAttribute('muted');
        videoElement.removeAttribute('loop');
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('preload', 'none'); // no preloading
        videoElement.setAttribute('loading', 'lazy'); // hint browser to lazy load
        this.addPlayButton(videoElement);
      }
    }

    addPlayButton(videoElement) {
      this.selectors.playButton?.addEventListener('click', () => {
        videoElement.play().then(() => {
          this.selectors.previewImage?.classList.remove('active');
        });
      });

      this.selectors.stopButton?.addEventListener('click', () => {
        videoElement.pause();
        videoElement.currentTime = 0;
        this.selectors.previewImage?.classList.add('active');
      });
    }
  }

  customElements.define('section-video', SectionVideo);
}